import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  isJobStatusLoading: false,
  job_statuses: null,
  isWorkCardLoading: false,
  isEqWorkCardLoading: false,
  work_cards: null,
  equipment_work_cards: null,
  isWorkCardShiftLoading: false,
  work_card_shift: null,
  crews: null,
  isJobTimeCardLoading: false,
  job_time_card: null,
  isEarnCodeLoading: false,
  earn_codes: null,
  isJobTypeLoading: false,
  job_type: null,
};

const slice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    // START LOADING
    startJobStatusLoading(state) {
      state.isJobStatusLoading = true;
      state.isWorkCardLoading = true;
    },
    startWorkCardLoading(state) {
      state.isJobStatusLoading = true;
      state.isWorkCardLoading = true;
    },
    startWorkCardShiftLoading(state) {
      state.isWorkCardShiftLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isJobStatusLoading = false;
      state.isWorkCardLoading = false;
      state.isWorkCardShiftLoading = false;
      state.isEqWorkCardLoading = false;
      state.error = action.payload;
    },

    startJobTimeCardLoading(state) {
      state.isJobTimeCardLoading = true;
    },

    // GET JOB Status
    setJobStatus(state, action) {
      state.isJobStatusLoading = false;
      state.job_statuses = action.payload;
    },
    // GET WORK CARD
    setWorkCard(state, action) {
      state.isWorkCardLoading = false;
      state.work_cards = action.payload;
    },
    setEqWorkCard(state, action) {
      state.isEqWorkCardLoading = false;
      state.equipment_work_cards = action.payload;
    },
    // GET WORK CARD SHIFT
    setWorkCardShift(state, action) {
      state.isWorkCardShiftLoading = false;
      state.work_card_shift = action.payload;
    },
    // GET JOB Status
    setCrews(state, action) {
      state.isJobStatusLoading = false;
      state.crews = action.payload;
    },
    //GET JOB TIME CARD
    setJobTimeCard(state, action) {
      state.isJobTimeCardLoading = false;
      state.job_time_card = action.payload;
    },
    startEarnCodeLoading(state) {
      state.isEarnCodeLoading = true;
    },
    setEarnCodes(state, action) {
      state.isEarnCodeLoading = false;
      state.earn_codes = action.payload;
    },
    startJobTypeLoading(state) {
      state.isJobTypeLoading = true;
    },
    setJobType(state, action) {
      state.job_type = action.payload;
      state.isJobTypeLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { startJobStatusLoading, startWorkCardLoading, startWorkCardShiftLoading, hasError } = slice.actions;

// ----------------------------------------------------------------------
export function getJobStatus() {
  return async () => {
    dispatch(slice.actions.startJobStatusLoading());
    try {
      const response = await axios.get(`/admin/job/job_statuses`);
      dispatch(slice.actions.setJobStatus(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getJobTimeCard() {
  return async () => {
    dispatch(slice.actions.startJobTimeCardLoading());
    try {
      const response = await axios.get(`/dropdown/job/time_card_types`);
      dispatch(slice.actions.setJobTimeCard(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCrews() {
  return async (dispatch) => {
    dispatch(slice.actions.startJobStatusLoading());
    try {
      const response = await axios.get(`/dropdown/job/crews`);
      const activeCrews = response.data.filter(crew => crew.status === 'active');
      dispatch(slice.actions.setCrews(activeCrews));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getWorkCard() {
  return async () => {
    dispatch(slice.actions.startWorkCardLoading());
    try {
      const response = await axios.get(`/dropdown/job/work_cards`);
      dispatch(slice.actions.setWorkCard(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getEqWorkCard() {
  return async () => {
    dispatch(slice.actions.startWorkCardLoading());
    try {
      const response = await axios.get(`/dropdown/job/equipment_work_cards`);
      dispatch(slice.actions.setEqWorkCard(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getWorkCardShift() {
  return async () => {
    dispatch(slice.actions.startWorkCardShiftLoading());
    try {
      const response = await axios.get(`/admin/job/work_card_shifts`);
      dispatch(slice.actions.setWorkCardShift(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEarnCodes(params = {}) {
  return async () => {
    dispatch(slice.actions.startEarnCodeLoading());
    try {
      const response = await axios.get(`/admin/job/earn_codes`, {
        params: params,
      });
      dispatch(slice.actions.setEarnCodes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getJobType(params = {}) {
  return async () => {
    dispatch(slice.actions.startJobTypeLoading());
    try {
      const response = await axios.get(`/admin/job/job_types`, {
        params: params,
      });
      dispatch(slice.actions.setJobType(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
